import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilePresentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"file_present"}/>
}
